import React from 'react'
import WelcomeNote from '../components/WelcomeNote'

const Welcome = () => {
  return (
    <div className='flex flex-row items-center justify-between w-full h-screen'>
        <WelcomeNote />
    </div>
  )
}

export default Welcome